module.exports = __webpack_public_path__ + "img/loading_banner.273fb233.jpg";